import {AxiosError} from 'axios';

interface ApiErrorResponse {
    success?: boolean;
    error?: string;
    message?: string;
    error_code?: string;
    details?: Record<string, any>;
}

export function extractErrorMessage(error: unknown, fallbackMessage?: string): string {
    if (!error) {
        return fallbackMessage || 'An unexpected error occurred';
    }

    if (error instanceof Error && !('response' in error)) {
        return error.message || fallbackMessage || 'An unexpected error occurred';
    }

    const axiosError = error as AxiosError<ApiErrorResponse>;
    const responseData = axiosError.response?.data;

    if (responseData) {
        if (responseData.error) {
            return responseData.error;
        }
        if (responseData.message) {
            return responseData.message;
        }
        if (typeof responseData === 'string') {
            return responseData;
        }
    }

    if (axiosError.message) {
        return axiosError.message;
    }

    return fallbackMessage || 'An unexpected error occurred';
}

export function isApiError(error: unknown): error is AxiosError<ApiErrorResponse> {
    return (
        typeof error === 'object' &&
        error !== null &&
        'response' in error &&
        'request' in error
    );
}

export function getErrorStatus(error: unknown): number | null {
    if (isApiError(error)) {
        return error.response?.status || null;
    }
    return null;
}

